<template>
  <div>
    <!-- <div class="snowflakes"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div> -->
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Marcar ponto
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div
            class="col-md-8 keypad"
            style="text-align: left"
          >
            <div class="keypad-grid">
              <button
                v-for="button in buttons"
                :key="button.number"
                class="check-box btn btn-primary"
                :aria-label="`digito-${button.number}`"
                :disabled="!(quickAccess.length < 14)"
                @click="addNumber(button.number)"
              >
                <div class="check-content">
                  {{ button.number }}
                </div>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="quick-access-display">
              {{ quickAccess }}
            </div>

            <div
              id="check-user-container"
              class="user-card"
            >
              <div class="user-image">
                <img
                  v-if="userChecking.photo"
                  :src="userChecking.photo"
                  alt="user photo"
                >
                <div
                  v-else
                  class="user-placeholder"
                  aria-hidden="true"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5z"
                    fill="#fff"
                  /><path
                    d="M3 21c0-3.866 3.582-7 9-7s9 3.134 9 7v1H3v-1z"
                    fill="#fff"
                  /></svg>
                </div>
              </div>
              <div class="user-info">
                <div class="user-name">
                  {{ userChecking.name }}
                </div>
                <div class="user-email text-muted">
                  {{ userChecking.email }}
                </div>
              </div>
            </div>

            <div class="action-row">
              <button
                class="btn btn-outline-secondary btn-sm btn-action"
                :disabled="quickAccess.length === 0"
                @click="removeOne()"
              >
                <i class="fas fa-long-arrow-alt-left" />
                <span class="d-none d-sm-inline"> Apagar</span>
              </button>

              <button
                class="btn btn-outline-danger btn-sm btn-action"
                :disabled="quickAccess.length === 0"
                title="Limpar"
                @click="clearAll()"
              >
                <i class="fas fa-eraser" />
                <span class="d-none d-sm-inline"> Limpar</span>
              </button>

              <button
                class="btn btn-outline-primary btn-sm btn-action"
                :disabled="quickAccess.length === 0 || isCapturing || isSending"
                title="Confirmar"
                @click="check()"
              >
                <i class="fas fa-check" />
                <span class="d-none d-sm-inline"> Confirmar</span>
              </button>

              <button
                class="btn btn-primary btn-sm btn-action btn-mark"
                :disabled="isCapturing || !checkEnabled || isSending"
                @click="openCameraAndStart()"
              >
                <div class="btn-mark-line">
                  Marcar
                </div>
                <small class="d-block">{{ nextCheckDescription }}</small>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        id="modalCameraCenter"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalCameraCenterTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body">
              <v-easy-camera
                ref="easyCamera"
                v-model="picture"
                :fullscreen="true"
                @approve="makeCheck"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EasyCamera from 'easy-vue-camera'

export default {
  components: {
    'v-easy-camera': EasyCamera,
  },
  data() {
    return {
      loading: false,
      step: 1,
      location: null,
      cameraIsStarted: false,
      lastImageData: null,
      movementDetected: false,
      isCapturing: false,
      picture: '',
      loadinng: false,
      isSending: false,
      userChecking: {
        name: '',
      },
      nextCheckDescription: '',
      quickAccess: '',
      buttons: [
        {
          number: 1,
        },
        {
          number: 2,
        },
        {
          number: 3,
        },
        {
          number: 4,
        },
        {
          number: 5,
        },
        {
          number: 6,
        },
        {
          number: 7,
        },
        {
          number: 8,
        },
        {
          number: 9,
        },
        {
          number: 0,
        },
      ],
    }
  },
  computed: {
    checkEnabled() {
      const self = this
      return self.quickAccess.length > 0 && self.userChecking.id
    },
  },
  watch: {
    loading(newVal, oldVal) {
      console.log(newVal)
      if (newVal) {
        $('#page_loader').show()
      } else {
        $('#page_loader').hide()
      }
    },
  },
  mounted() {
    $('#headerNavBar').hide()
    $('#sidebar').hide()
    $('#breadCrumb').hide()

    const self = this
    const { id } = self.$route.params
    self.getLocation()

    if (id) {
      self.getUser(id)
    }

    try {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen()
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen()
      }
    } catch (error) {
      console.error('Tela cheia não suportada ou permissões negadas:', error)
    }

    try {
      const mq = window.matchMedia('(min-width: 768px) and (orientation: landscape)')
      const applyHide = m => {
        const headerEl = document.querySelector('.header-navbar, #headerNavBar, nav.header-navbar')
        if (!headerEl) return
        if (m.matches) {
          headerEl.classList.add('d-none', 'hidden-by-check')
          this._hidHeaderNavbar = headerEl
        } else if (this._hidHeaderNavbar) {
          this._hidHeaderNavbar.classList.remove('d-none', 'hidden-by-check')
          this._hidHeaderNavbar = null
        }
      }

      applyHide(mq)

      if (typeof mq.addEventListener === 'function') {
        this._headerMqListener = ev => applyHide(ev.target || ev)
        mq.addEventListener('change', this._headerMqListener)
      } else if (typeof mq.addListener === 'function') {
        this._headerMqListener = ev => applyHide(ev)
        mq.addListener(this._headerMqListener)
      }
      this._headerMq = mq
    } catch (e) {
      console.error('Error setting up header hide media query:', e)
    }
  },
  destroyed() {
    $('#headerNavBar').show()
    $('#sidebar').show()
    $('#breadCrumb').show()
    try {
      if (this._hidHeaderNavbar) {
        this._hidHeaderNavbar.classList.remove('d-none', 'hidden-by-check')
        this._hidHeaderNavbar = null
      }
      if (this._headerMq && this._headerMqListener) {
        if (typeof this._headerMq.removeEventListener === 'function') {
          this._headerMq.removeEventListener('change', this._headerMqListener)
        } else if (typeof this._headerMq.removeListener === 'function') {
          this._headerMq.removeListener(this._headerMqListener)
        }
        this._headerMq = null
        this._headerMqListener = null
      }
    } catch (e) {}

    $('body').removeClass('check')
  },
  beforeCreate() {
    $('body').addClass('check')
  },
  methods: {
    openCameraAndStart() {
      this.cameraOpen()
      this.startCamera()
    },
    removeOne() {
      const self = this
      if (self.userChecking.id) {
        self.clearUserChecking()
      }
      self.quickAccess = self.quickAccess.substring(
        0,
        self.quickAccess.length - 1,
      )
    },
    clearUserChecking() {
      const self = this
      self.userChecking = {
        name: '',
      }
    },
    addNumber(number) {
      const self = this
      if (!(self.quickAccess.length < 14)) return

      self.quickAccess += number
    },
    resetCapture(video) {
      this.movementDetected = false
      this.isCapturing = false
      video.style.display = 'none'
    },
    handlePicture() {
      this.isCapturing = true
      try { this.$loading(true) } catch (e) {}
      const imageData = this.picture
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const img = new Image()
      img.onload = () => {
        const width = 640
        const height = (img.height / img.width) * width
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        const compressedImage = canvas.toDataURL('image/jpeg', 0.7)
        this.picture = compressedImage

        this.getLocation()

        setTimeout(() => {
          if (this.location) {
            const api = `${this.$store.state.api}checks/remoteCheck`
            axios.post(api, {
              picture: compressedImage,
              location: this.location,
              user_id: this.userChecking?.id ?? null,
              quick_access: this.quickAccess || null,
            })
              .then(async response => {
                if (response.data.status === 'success' || response.data.status === '00') {
                  this.cameraIsStarted = false
                  this.isCapturing = false
                  $('#modalCameraCenter').modal('hide')
                  try { this.$loading(false) } catch (e) {}
                  this.$message('Sucesso', 'Ponto registrado com sucesso!', 'success')
                  setTimeout(() => { window.location.reload() }, 500)
                } else {
                  swal('Ops!', response.data.message, 'error').then(() => {
                    window.location.reload()
                  })
                  this.isCapturing = false
                  try { this.$loading(false) } catch (e) {}
                }
              })
              .catch(error => {
                const errorMessage = error.response?.data?.message || 'Erro desconhecido'
                swal('Ops!', errorMessage, 'error').then(() => {
                  window.location.reload()
                })
                this.isCapturing = false
                try { this.$loading(false) } catch (e) {}
                $('#modalCameraCenter').modal('hide')
              })
          } else {
            this.isCapturing = false
            try { this.$loading(false) } catch (e) {}
            $('#modalCameraCenter').modal('hide')
            setTimeout(() => { window.location.reload() }, 1000)
          }
        }, 1000)
      }
      img.src = imageData
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            }
            this.error = null
          },
          error => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                this.error = 'Usuário negou a solicitação de Geolocalização.'
                break
              case error.POSITION_UNAVAILABLE:
                this.error = 'A localização não está disponível.'
                break
              case error.TIMEOUT:
                this.error = 'A solicitação de localização expirou.'
                break
              case error.UNKNOWN_ERROR:
                this.error = 'Um erro desconhecido ocorreu.'
                break
            }
          },
        )
      } else {
        this.error = 'Geolocalização não é suportada pelo navegador.'
      }
    },

    detectMovement(currentImageData) {
      if (this.lastImageData) {
        let diff = 0
        const { length } = currentImageData.data
        for (let i = 0; i < length; i += 4) {
          const r = currentImageData.data[i]
          const g = currentImageData.data[i + 1]
          const b = currentImageData.data[i + 2]
          const currentBrightness = (r + g + b) / 3

          const lr = this.lastImageData.data[i]
          const lg = this.lastImageData.data[i + 1]
          const lb = this.lastImageData.data[i + 2]
          const lastBrightness = (lr + lg + lb) / 3

          if (Math.abs(currentBrightness - lastBrightness) > 10) {
            diff++
          }
        }
        this.movementDetected = diff > 1000
      }
      this.lastImageData = currentImageData
    },
    startCamera() {
      const self = this
      if (self.location == null) {
        swal(
          'Ops!',
          'Você precisa fornecer acesso a localização do dispositivo, sem o devido acesso, não será possível registrar a marcação.',
          'error',
        )
        return
      }
      self.cameraIsStarted = true

      $('#modalCameraCenter').modal('show')
    },
    cameraOpen() {
      const self = this
      self.cameraIsStarted = true

      if (self.location == null) {
        return
      }
      setTimeout(() => {
        self.$refs.easyCamera.snap()
        setTimeout(() => {
          self.handlePicture()
        }, 1000)
      }, 3500)
    },
    capture() {
      this.isCapturing = true
      $('#modalCameraCenter').modal('show')
      const { video } = this.$refs
      const { canvas } = this.$refs
      const context = canvas.getContext('2d')

      const profileImage = this.$store.state.user.photo

      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(stream => {
          video.srcObject = stream
          video.style.display = 'block'

          const checkMovement = setInterval(() => {
            context.drawImage(video, 0, 0, canvas.width, canvas.height)
            const currentImageData = context.getImageData(
              0,
              0,
              canvas.width,
              canvas.height,
            )
            this.detectMovement(currentImageData)

            if (this.movementDetected) {
              clearInterval(checkMovement)
              const imageData = canvas.toDataURL('image/jpeg')

              this.getLocation()

              setTimeout(() => {
                if (this.location) {
                  const api = `${this.$store.state.api}checks/checks`

                  axios
                    .post(api, {
                      picture: imageData,
                      location: this.location,
                      user_id: this.userChecking?.id ?? null,
                      quick_access: this.quickAccess || null,
                    })
                    .then(async response => {
                      if (response.data.status === 'success' || response.data.status === '00') {
                        this.picture = null
                        this.cameraIsStarted = true
                        this.isCapturing = false
                        $('#modalCameraCenter').modal('hide')
                        this.$loading(false)

                        this.quickAccess = ''
                        this.userChecking.photo = ''
                        this.userChecking.name = ''
                        this.userChecking.email = ''
                        this.$message(
                          'Sucesso',
                          'Ponto registrado com sucesso!',
                          'success',
                        )
                      } else {
                        console.log('aqui2', response.data)
                        this.quickAccess = ''
                        this.userChecking.photo = ''
                        this.userChecking.name = ''
                        this.userChecking.email = ''
                        swal('Ops!', response.data.message, 'error')
                        this.isCapturing = false
                        this.$loading(false)
                        $('#modalCameraCenter').modal('hide')
                      }
                    })
                    .catch(error => {
                      console.log('Erro na requisição:', error)
                      this.quickAccess = ''
                      this.userChecking.photo = ''
                      this.userChecking.name = ''
                      this.userChecking.email = ''
                      const errorMessage = error.response?.data?.message
                              || error.message
                              || 'Erro desconhecido'
                      swal('Ops!', errorMessage, 'error')
                      this.isCapturing = false
                      this.$loading(false)
                      $('#modalCameraCenter').modal('hide')
                    })
                } else {
                  this.resetCapture(video)
                  this.quickAccess = ''
                  this.userChecking.photo = ''
                  this.userChecking.name = ''
                  this.userChecking.email = ''
                  $('#modalCameraCenter').modal('hide')
                  this.cameraIsStarted = false
                  this.isCapturing = false
                }
              }, 1000)
            }
          }, 100)
        })
        .catch(err => {
          console.error('Erro ao acessar a câmera: ', err)
          this.isCapturing = false
          $('#modalCameraCenter').modal('hide')
          this.$loading(false)
        })
    },

    async makeCheck(pictureFromCamera) {
      this.loadinng = true
      this.isSending = true
      const self = this
      const api = `${this.$store.state.api}checks/remoteCheck`

      if (pictureFromCamera) {
        this.picture = pictureFromCamera
      }

      try {
        self.$loading(true)

        let compressedImage = this.picture
        if (this.picture) {
          try {
            const img = await new Promise((resolve, reject) => {
              const i = new Image()
              i.onload = () => resolve(i)
              i.onerror = reject
              i.src = this.picture
            })

            const width = 640
            const height = (img.height / img.width) * width
            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)
            compressedImage = canvas.toDataURL('image/jpeg', 0.7)
            this.picture = compressedImage
          } catch (e) {
            console.warn('image compress failed, sending original', e)
          }
        }

        if (!this.location) {
          this.getLocation()
          const waited = await new Promise(resolve => {
            const start = Date.now()
            const tick = () => {
              if (this.location) return resolve(true)
              if (Date.now() - start > 3000) return resolve(false)
              setTimeout(tick, 200)
            }
            tick()
          })
          if (!waited) console.warn('location not available before sending check')
        }

        try { $('#modalCameraCenter').modal('hide') } catch (e) {}
        this.cameraIsStarted = false

        const payload = {
          picture: compressedImage,
          location: this.location,
          user_id: this.userChecking?.id ?? null,
          quick_access: this.quickAccess || null,
        }

        const response = await axios.post(api, payload)

        if (response.data && (response.data.status === 'success' || response.data.status === '00')) {
          this.cameraIsStarted = false
          this.isCapturing = false
          this.picture = null
          this.quickAccess = ''
          this.userChecking = { name: '' }
          this.loadinng = false
          self.$loading(false)
          this.$message('Sucesso', 'Ponto registrado com sucesso!', 'success')
          setTimeout(() => { window.location.reload() }, 500)
        } else {
          const msg = response.data?.message || 'Erro ao registrar ponto'
          swal('Ops!', msg, 'error').then(() => {
            window.location.reload()
          })
          this.isCapturing = false
          this.loadinng = false
          try { self.$loading(false) } catch (e) {}
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Erro desconhecido'
        swal('Ops!', errorMessage, 'error').then(() => {
          window.location.reload()
        })
        this.isCapturing = false
        this.loadinng = false
        try { self.$loading(false) } catch (e) {}
        try { $('#modalCameraCenter').modal('hide') } catch (e) {}
      } finally {
        this.isSending = false
      }
    },
    clearAll() {
      const self = this;

      (self.quickAccess = ''),
      (self.userChecking = {
        name: '',
      })
    },
    makeFormData() {
      const self = this

      const fd = new FormData()
      fd.append('user_id', self.userChecking.id)

      return fd
    },
    check() {
      const self = this
      self.loading = true
      const api = `${this.$store.state.api}users?quick_access=${self.quickAccess}`

      axios
        .get(api)
        .then(response => {
          const foundUser = response.data.data

          if (foundUser.length === 0) {
            self.$message('Erro', 'Usuário não encontrado.', 'error')
            self.loading = false
            self.quickAccess = ''

            return
          }

          if (foundUser.length === 1) {
            self.step = 2

            const userChecking = response.data.data[0]
            const todayChecks = `${this.$store.state.api}checks/today?user_id=${userChecking.id}`
            axios
              .get(todayChecks)
              .then(response => {
                const checks = response.data
                if (checks.length === 0) {
                  self.nextCheckDescription = 'Entrada'
                } else if (checks.length === 1) {
                  self.nextCheckDescription = 'Almoço'
                } else if (checks.length === 2) {
                  self.nextCheckDescription = 'Volta almoço'
                } else if (checks.length === 3) {
                  self.nextCheckDescription = 'Saída'
                } else {
                  self.nextCheckDescription = 'Extra'
                }

                self.userChecking = userChecking
              })
              .catch(error => {
                console.log(error)
                self.$message('Erro', error.response.data, 'error')
              })
          }
          self.loading = false
        })
        .catch(error => {
          self.$message('Erro', error.response.data, 'error')
          self.loading = false
        })
    },

    getUser(id) {
      console.log(`getting user ${id}`)
      const self = this
      const api = `${self.$store.state.api}users/${id}`

      axios
        .get(api)
        .then(response => {
          self.user = response.data.data[0]
          console.log(self.user)
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
  },
}
</script>

<style scoped>
.fullscreen-mode .card {
  width: 100vw !important;
  height: 100vh !important;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 0;
  box-shadow: none;
}

.fullscreen-mode .card-body {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.video-container {
  position: relative;
  width: 100%;
  height: 60vh;
  max-height: 480px;
  margin-bottom: 1rem;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover; /* cobre todo container, podendo cortar */
  border-radius: 8px;
}

.check-box {
  flex: 0 0 22%;
  max-width: 22%;
  margin: 0.5rem;
  min-width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0,0,0,0.08);
  transition: transform .08s ease, box-shadow .08s ease;
}

.check-content {
  /* make the content fill the button and center the number both vertically and horizontally */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  text-align: center;
  font-size: 1.6rem;
  user-select: none;
  cursor: pointer;
}

.keypad-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.check-box:active,
.check-box:focus {
  transform: translateY(2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.12);
}

/* make sure keypad buttons use the system primary color and readable text */
.check-box.btn-primary {
  color: #fff;
  background-color: var(--bs-primary, #007bff);
  border-color: var(--bs-primary, #007bff);
}
.check-box.btn-primary:disabled {
  opacity: 0.55;
}

.user-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
  min-height: 96px; /* keep card height stable so layout doesn't shift when photo/name change */
}

.user-image {
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: #e9ecef; /* neutral background when no photo */
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.user-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #8aa4d8; /* gentle primary shade for placeholder */
}

.user-info .user-name {
  font-weight: 600;
}

.user-info .user-email {
  font-size: 0.9rem;
}

.action-row {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.9rem;
  align-items: center;
}

.btn-action {
  padding: 0.45rem 0.6rem;
}

.btn-mark {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.btn-mark-line {
  line-height: 1;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .check-box {
    flex: 1 1 28%;
    max-width: 28%;
  }

  #check-backspace-container,
  #check-check-container {
    margin-top: 1rem;
  }

  #check-backspace {
    font-size: 1rem;
    padding: 0.5rem;
  }

  .fullscreen-mode .card-body {
    flex-direction: column;
    align-items: stretch;
  }
}

@media (max-width: 480px) {
  .check-box {
    flex: 1 1 40%;
    max-width: 40%;
    margin: 0.3rem 0.2rem;
  }

  .check-content {
    font-size: 1.2rem;
    padding: 0.8rem 0;
  }
}

/* Tablet landscape: hide header and enlarge keypad / image for more fluid side-by-side layout */
@media (min-width: 768px) and (orientation: landscape) {
  .card-header { display: none; }
  .check-box { min-width: 72px; height: 72px; border-radius: 14px; }
  .check-content { font-size: 1.8rem; }
  .user-image { width: 80px; height: 80px; }
  .card-body { padding: 1.25rem; }
}
</style>
